import { LocalStorageKeys } from "@/constants/localStorageKeys";

export function toggleDarkModeTheme(state, isAutoSet) {
  document.documentElement.classList.toggle("dark-mode", state);
  !isAutoSet && setDarkModeLocalStorage(state);
}

function setDarkModeLocalStorage(state) {
  localStorage.setItem(LocalStorageKeys.DarkMode, JSON.stringify(state));
}

export function setPreferredTheme() {
  const storedSavedSetting = localStorage.getItem(LocalStorageKeys.DarkMode);
  const savedSetting = JSON.parse(storedSavedSetting);

  const prefersDarkThemeNatively = window.matchMedia(
    "(prefers-color-scheme: dark)"
  ).matches;

  if (storedSavedSetting) {
    return toggleDarkModeTheme(savedSetting, true);
  }

  return toggleDarkModeTheme(prefersDarkThemeNatively, true);
}
